import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiBell } from "react-icons/fi";

const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";
const MAIL_API = process.env.REACT_APP_MAIL_API;

export default function WhatsNewBell({ activeDoerEmail, activeDoerName }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [newest, setNewest] = useState([]);
  const [doerCount, setDoerCount] = useState(0);
const [doerList, setDoerList] = useState([]);
  const boxRef = useRef(null);
  const navigate = useNavigate();

async function refresh() {
  if (!activeDoerEmail) return { count: 0, newest: [], doerCount: 0 };

  // 1️⃣ WhatsNew
  const res1 = await fetch(
  `${API_BASE}/whatsnew/unseenCount?email=${encodeURIComponent(activeDoerEmail)}`,
  {
    method: "GET",
    credentials: "include", // ✅
  }
);
  const json1 = await res1.json();

  const wnCount = Number(json1.count || 0);
  const wnNewest = json1.newest || [];

  // 2️⃣ Doer notifications
const res2 = await fetch(
  `${MAIL_API}/notifications/count?email=${encodeURIComponent(activeDoerEmail)}`,
  {
    method: "GET",
    credentials: "include", // ✅
  }
);
  const json2 = await res2.json();

  const dCount = Number(json2.count || 0);

  // OPTIONAL: fetch latest notifications
const res3 = await fetch(
  `${MAIL_API}/notifications?email=${encodeURIComponent(activeDoerEmail)}`,
  {
    method: "GET",
    credentials: "include", // ✅
  }
);
  const json3 = await res3.json();

  const dList = json3.data || [];

  // SET STATE
  setCount(wnCount);
  setNewest(wnNewest);

  setDoerCount(dCount);
  setDoerList(dList);

  return {
    count: wnCount,
    newest: wnNewest,
    doerCount: dCount
  };
}


  useEffect(() => {
    refresh();
    // small auto refresh every 30s (optional)
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [activeDoerEmail]);

  // close popup when clicking outside
  useEffect(() => {
    function onDoc(e) {
      if (!open) return;
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

async function markSeenAll() {
  if (!activeDoerEmail) return;

  // WhatsNew
  await fetch(`${API_BASE}/whatsnew/markSeen`, {
    method: "POST",
    credentials: "include", // ✅
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: activeDoerEmail }),
  }).catch(() => {});

  // Doer notifications
  await fetch(`${MAIL_API}/notifications/mark-seen`, {
    method: "POST",
    credentials: "include", // ✅
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: activeDoerEmail }),
  }).catch(() => {});

  await refresh();
}

async function logOpen(source, itemId) {
  if (!activeDoerEmail) return;

  const payload = {
    email: activeDoerEmail,
    name: activeDoerName || null,
    source,
  };
  if (itemId) payload.itemId = itemId; // ✅

  fetch(`${API_BASE}/whatsnew/logOpen`, {
    method: "POST",
     credentials: "include", // ✅
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => {});
}


  function scrollToSection() {
    const el = document.getElementById("whats-new-section");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  return (
    <div style={{ position: "relative" }} ref={boxRef}>
      <button
onClick={async () => {
  const next = !open;
  setOpen(next);

  if (next) {
    const { newest: n } = await refresh();
    const firstId = n?.[0]?.id || null;

    await logOpen("BELL_POPUP", firstId);

    // 🔥 ADD THIS (AUTO MARK SEEN)
    await fetch(`${MAIL_API}/notifications/mark-seen`, {
      method: "POST",
      credentials: "include", // ✅
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: activeDoerEmail }),
    });

    await refresh();
  }
}}
        style={{
          position: "relative",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontSize: 14,
        }}
        title="What’s New"
      >
        <FiBell size={16} />
        {(count + doerCount) > 0 ? (
          <span
            style={{
              position: "absolute",
              top: -6,
              right: -5,
              background: "#e11d48",
              color: "#fff",
              borderRadius: 999,
              padding: "2px 6px",
              fontSize: 11,
              fontWeight: 800,
              lineHeight: "14px",
              minWidth: 18,
              textAlign: "center",
            }}
          >
            {count + doerCount}
          </span>
        ) : null}
      </button>

      {open ? (
        <div
          style={{
            position: "absolute",
            right: -20,
            top: 30,
            width: 350,
            background: "#fff",
            border: "1px solid rgba(0,0,0,0.10)",
            borderRadius: 12,
            boxShadow: "0 10px 30px rgba(0,0,0,0.10)",
            padding: 12,
            zIndex: 9999,
            height: "90vh",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ fontWeight: 800 }}>New Updates</div>
            <button
              onClick={() => setOpen(false)}
              style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: 14 }}
              title="Close"
            >
              ✕
            </button>
          </div>

          <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 8 }}>
            {newest.length === 0 ? (
              <div style={{ fontSize: 12, opacity: 0.7 }}>No new updates.</div>
            ) : (
              newest.map((n) => (
                <div
                  key={n.id}
                  style={{ fontSize: 13, padding: 8, borderRadius: 10, background: "rgba(0,0,0,0.03)" }}
                >
                  <div style={{ fontWeight: 800 }}>{n.title}</div>
                  <div style={{ fontSize: 12, opacity: 0.7 }}>{String(n.type || "")}</div>
                </div>
              ))
            )}
          </div>

          
{/* 🔥 DOER NOTIFICATIONS */}
{/* 🔥 DOER NOTIFICATIONS */}
{doerList.length > 0 && (() => {

  const hodList = doerList.filter(
    n => String(n.type || "").trim().toUpperCase() === "HOD_PENDING"
  );

  const scoreList = doerList.filter(
    n => String(n.type || "").trim().toUpperCase() === "DOER_UPDATE"
  );

  return (
    <div style={{ marginTop: 12 }}>

      {/* 🔥 HOD SECTION */}
      {hodList.length > 0 && (
        <div style={{ marginBottom: 14 }}>

          <div
            style={{
              fontSize: 12,
              fontWeight: 800,
              marginBottom: 8,
              color: "#92400e",
              display: "flex",
              alignItems: "center",
              gap: 6
            }}
          >
            ⏳ Pending Approvals ({hodList.length})
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {hodList.slice(0, 5).map((n) => (

              <div
                key={n.id}
                onClick={async () => {

                  if (n.link) {
                    navigate(n.link);
                  }

                  await fetch(`${MAIL_API}/notifications/mark-seen`, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email: activeDoerEmail }),
                  });

                  await refresh();
                  setOpen(false);

                }}
                style={{
                  background: "#fff8e1",
                  border: "1px solid #fcd34d",
                  borderRadius: 12,
                  padding: "6px 10px",
                  cursor: "pointer",
                  transition: "0.2s",
                }}
              >

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >

                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#78350f"
                    }}
                  >
                    Pending Approval
                  </div>

                  <div
                    style={{
                      fontSize: 10,
                      color: "#863b0c",
                      opacity: 0.8
                    }}
                  >
                    {new Date(
                      n.created_at?.value || n.created_at
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit"
                    })}
                  </div>

                </div>

                <div
                  style={{
                    fontSize: 11,
                    color: "#78350f",
                    marginBottom: 5
                  }}
                >
                  {n.message}
                </div>

                <div
                  style={{
                    fontSize: 10,
                    color: "#7a380f",
                    opacity: 0.8
                  }}
                >
                 📅 Date: {
  n.grid_date
    ? (() => {
        const d = new Date(n.grid_date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
      })()
    : "-"
}
                </div>

              </div>

            ))}
          </div>
        </div>
      )}

      {/* 🔥 SCORE UPDATE SECTION */}
      {scoreList.length > 0 && (
        <div>

          <div
            style={{
              fontSize: 12,
              fontWeight: 800,
              marginBottom: 8,
              color: "#166534",
              display: "flex",
              alignItems: "center",
              gap: 6
            }}
          >
            ✅ Score Updates ({scoreList.length})
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {scoreList.slice(0, 5).map((n) => (

              <div
                key={n.id}
                onClick={async () => {

                  if (n.link) {
                    navigate(n.link);
                  }

                  await fetch(`${MAIL_API}/notifications/mark-seen`, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email: activeDoerEmail }),
                  });

                  await refresh();
                  setOpen(false);

                }}
                style={{
                  background: "#ecfdf3",
                  border: "1px solid #86efac",
                  borderRadius: 12,
                  padding: "6px 10px",
                  cursor: "pointer",
                  transition: "0.2s",
                }}
              >

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >

                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#166534"
                    }}
                  >
                    Score Review Completed
                  </div>

                  <div
                    style={{
                      fontSize: 10,
                      color: "#166534",
                      opacity: 0.8
                    }}
                  >
                    {new Date(
                      n.created_at?.value || n.created_at
                    ).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit"
                    })}
                  </div>

                </div>

                <div
                  style={{
                    fontSize: 11,
                    color: "#166534",
                    marginBottom: 5
                  }}
                >
                  {n.message}
                </div>

                <div
                  style={{
                    fontSize: 10,
                    color: "#166534",
                    opacity: 0.8
                  }}
                >
                📅 Date: {
  n.grid_date
    ? (() => {
        const d = new Date(n.grid_date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
      })()
    : "-"
}
                </div>

              </div>

            ))}
          </div>
        </div>
      )}

    </div>
  );

})()}

          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            <button
              onClick={async () => {
                scrollToSection();
                await markSeenAll(); // ✅ remove count after click
                setOpen(false);
              }}
              style={{
                flex: 1,
                padding: "8px 10px",
                borderRadius: 10,
                border: "1px solid rgba(0,0,0,0.15)",
                cursor: "pointer",
                fontWeight: 700,
                background: "#fff",
              }}
            >
              View What’s New
            </button>

            {(count + doerCount) > 0 ? (
              <button
                onClick={async () => {
                  await markSeenAll();
                }}
                style={{
                  padding: "8px 10px",
                  borderRadius: 10,
                  border: "1px solid rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  fontWeight: 700,
                  background: "#fff",
                }}
                title="Mark all as seen"
              >
                Seen
              </button>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}

// import React from "react";

// export default function WhatsNewBell() {
//   return (
//     <div>
//       Hello World
//     </div>
//   );
// }